import { render, staticRenderFns } from "./LearningLists.vue?vue&type=template&id=31238375&scoped=true&"
import script from "./LearningLists.vue?vue&type=script&lang=js&"
export * from "./LearningLists.vue?vue&type=script&lang=js&"
import style0 from "./LearningLists.vue?vue&type=style&index=0&id=31238375&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31238375",
  null
  
)

export default component.exports